"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ICONS = void 0;
var ICONS = {
  eye: "fa fa-eye",
  link: "fa fa-link",
  check: "fa fa-check",
  download: "fa fa-cloud-download",
  hamburger: "fa fa-bars",
  info: "fa fa-info-circle",
  arrowDown: "fa fa-arrow-down",
  arrowUp: "fa fa-arrow-up",
  improve: "fa fa-commenting-o"
};
exports.ICONS = ICONS;
var _default = {
  ICONS: ICONS
};
exports["default"] = _default;